import type { List } from '@/modules/dashboard/dashboardTypes';
import type { RootState } from '@/rootReducer';
import { shallowEqual, useSelector } from 'react-redux';

type UseListDetailsProps = {
	id: string;
};

export const useListDetails = ({ id }: UseListDetailsProps) => {
	const [lists] = useSelector<RootState, [Array<List>]>(
		state => [state.dashboard.getIn(['lists', 'data']).toJS()],
		shallowEqual
	);

	const findList = lists.find(list => list.id === id);

	return { list: findList };
};
